import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import moment from 'moment'
const model = (payload) => ({
  // columns
  id: payload.id,
  invoice_id: payload.invoice_id,
  amount: payload.amount,
  date: moment(payload.date).format('YYYY-MM-DD'),
  type: payload.type,
  receipt: payload.receipt
})
var crud = new Crud('Payments', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  payments: [],
  catalog: {
    invoices: []
  }
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  payments: state => state.payments
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
